import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionProps {
  emoji: string;
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  previewImage?: string;
}
export function Accordion({
  emoji,
  title,
  children,
  defaultOpen = false,
  previewImage
}: AccordionProps) {
  const [open, setOpen] = useState(defaultOpen);
  return <div className="overflow-hidden rounded-xl border border-white/10 bg-[#111]/90" data-id="element-17" data-mp="2n2e4nj0hbao6">
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} className="w-full text-left" data-id="element-18" data-mp="2i3t6rq8p932w">
        {previewImage && <div className="border-b border-white/10 bg-black/30 p-2.5" data-id="element-19" data-mp="2s2se95hqasob">
            <img src={previewImage} alt="" className="h-28 w-full rounded-lg border border-white/10 object-cover object-top" data-id="element-20" data-mp="11qmi9tjrcr44" />
          </div>}
        <div className="flex items-center gap-3 px-4 py-4" data-id="element-21" data-mp="3g4do8ihvl026">
          <span className="text-xl leading-none" aria-hidden="true" data-id="element-22" data-mp="3g5x62dj6jj62">
            {emoji}
          </span>
          <span className="flex-1 font-oswald text-[15px] font-600 leading-tight text-white" data-id="element-23" data-mp="3l143j3luvrmj">
            {title}
          </span>
          <ChevronDownIcon className={`h-5 w-5 shrink-0 text-[#F5C518] transition-transform duration-300 ${open ? 'rotate-180' : ''}`} data-id="element-24" data-mp="3usqbmr2wdal2" />
        </div>
      </button>
      <AnimatePresence initial={false} data-id="element-25" data-mp="3p1pxgr0rtmi">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-26" data-mp="7mpkgiosvkdv">
            <div className="border-t border-white/10 px-4 py-4" data-id="element-27" data-mp="2bcvnzbamig4i">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}